import {
  Box,
  Button,
  Input,
  InputGroup,
  InputRightElement,
  Spacer,
  Stack,
  Heading,
  Text,
} from '@chakra-ui/react';
import ErrorMessage from '@components/ErrorMessage';
import FormControl from '@components/FormControl';
import MyImage from '@components/MyImage';
import { configEnv } from '@libraries/config';
import Link from 'next/link';
import { memo } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { FiMail, FiBriefcase } from 'react-icons/fi';
import { useAction } from '../Register.action';

const Form: React.FC = (): JSX.Element => {
  const { formik, isShowPassword, onShowPassword, isLoading } = useAction();

  const handleKeyDown = (e) => {
    if (e.key === ' ') {
      e.preventDefault();
    }
  };

  const handlePasswordInput = (e) => {
    const value = e.target.value.replace(/\s/g, '');
    formik.setFieldValue('password', value);
  };

  return (
    <Box>
      <MyImage
        src={`${configEnv.assetUrl}/logo.jpeg`}
        alt={configEnv.appName}
        w="250px"
        h="60px"
        objectFit="contain"
        loading="lazy"
      />
      <Heading mt="8" size="lg">
        Daftar Akun Baru
      </Heading>
      <Text fontSize="lg" color="font.pencil" fontWeight="medium">
        Buat akun perusahaan Anda untuk mulai menggunakan Carte WMS.
      </Text>
      <Spacer h="10" />
      <form onSubmit={formik.handleSubmit}>
        <Stack spacing={4}>
          <FormControl
            id="company_name"
            label="Nama Perusahaan"
            isInvalid={Boolean(
              formik.errors.company_name && formik.touched.company_name,
            )}
          >
            <InputGroup size="lg">
              <Input
                pr="3rem"
                placeholder="Masukan nama perusahaan"
                name="company_name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values?.company_name}
              />
              <InputRightElement width="3rem">
                <FiBriefcase />
              </InputRightElement>
            </InputGroup>
            <ErrorMessage
              message={
                formik.touched.company_name && formik.errors.company_name
              }
            />
          </FormControl>
          <FormControl
            id="email"
            label="Email"
            isInvalid={Boolean(formik.errors.email && formik.touched.email)}
          >
            <InputGroup size="lg">
              <Input
                pr="3rem"
                placeholder="Masukan email"
                name="email"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values?.email}
              />
              <InputRightElement width="3rem">
                <FiMail />
              </InputRightElement>
            </InputGroup>
            <ErrorMessage
              message={formik.touched.email && formik.errors.email}
            />
          </FormControl>
          <FormControl
            id="password"
            label="Password"
            isInvalid={Boolean(
              formik.errors.password && formik.touched.password,
            )}
          >
            <InputGroup size="lg">
              <Input
                pr="3rem"
                placeholder="Masukan password"
                type={isShowPassword ? 'text' : 'password'}
                name="password"
                value={formik.values?.password}
                onKeyDown={handleKeyDown}
                onChange={handlePasswordInput}
                onBlur={formik.handleBlur}
              />
              <InputRightElement
                width="3rem"
                onClick={onShowPassword}
                cursor="pointer"
              >
                {isShowPassword ? <FaEye /> : <FaEyeSlash />}
              </InputRightElement>
            </InputGroup>
            <ErrorMessage
              message={formik.touched.password && formik.errors.password}
            />
          </FormControl>
        </Stack>
        <Spacer h="8" />
        <Button
          size="xl"
          w="full"
          color={'white'}
          isLoading={isLoading}
          isDisabled={!(formik.isValid && formik.dirty) || isLoading}
          type="submit"
        >
          Daftar
        </Button>
        <Spacer h="4" />
        <Text textAlign="center" fontSize="sm" color="font.pencil">
          Sudah punya akun?{' '}
          <Link href="/login" passHref>
            <Button variant="link" colorScheme="blue" size="sm">
              Masuk
            </Button>
          </Link>
        </Text>
      </form>
    </Box>
  );
};

export default memo(Form);
